export default __webpack_public_path__ + "static/media/bo_1.4fd662b2.mp3";